import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/AppShell";
import { api } from "@/lib/api";
import { useErrorToast } from "@/lib/hooks";
import { useI18n } from "@/i18n/I18n";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const showErr = useErrorToast();
  const [password, setPassword] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      toast.success(t("auth.resetDone"));
      navigate("/login", { replace: true });
    } catch (err) { showErr(err); }
  };
  return (
    <div className="min-h-screen grid-paper flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 rounded-2xl border border-slate-200 bg-white p-8 fade-up">
        <Logo />
        <h1 data-testid="reset-title" className="text-2xl font-extrabold">{t("auth.resetTitle")}</h1>
        <Input data-testid="reset-password-input" type="password" minLength={6} className="h-12" placeholder={t("auth.password")} value={password} onChange={(e) => setPassword(e.target.value)} required autoFocus />
        <Button data-testid="reset-submit-button" type="submit" className="w-full h-12">{t("common.save")}</Button>
      </form>
    </div>
  );
}
